import React from 'react'
import ReactDOM from 'react-dom'
import styled, { css } from 'styled-components'
import { MEDIA_QUERY } from '../config/constants'

import { Icon } from './shard'
import { Color } from 'const'

const Alert = ({ message, description, type, closable = true, onClose }) => {
  return ReactDOM.createPortal(
    <AlertWrapper type={type}>
      <Close onClick={onClose}>{closable && <Icon icon="close" size={16} color="#fff" />}</Close>
      <strong>{message}</strong>
      <Description>{description}</Description>
    </AlertWrapper>,
    document.getElementById('alert')
  )
}

export default Alert

const AlertWrapper = styled.div`
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  top: 10vh;
  width: 300px;
  padding: 16px;
  z-index: 100;

  ${MEDIA_QUERY.SP} {
    top: 12vh;
  }

  ${({ type }) => {
    let backgroundColor = 'inherit'
    let color = 'inherit'
    switch (type) {
      case 'info':
      case 'warning':
      case 'error':
        backgroundColor = Color.FONT.DANGER
        color = Color.WHITE
        break
      case 'success':
        backgroundColor = Color.BACKGROUND.GREEN
        break
      default:
    }

    return css`
      background-color: ${backgroundColor};
      color: ${color};
    `
  }}
`

// FIXME: I don't like styled.div, how to use css class?
const Close = styled.div`
  position: absolute;
  right: 16px;
  top: 16px;
  cursor: pointer;
`

const Description = styled.p`
  white-space: pre-wrap;
`
